import { selectRsInitVoidTransaction, selectRsVoidTransactionDetails } from 'selectors/request.selectors';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const selectReqStatVoidTransaction = (state) =>
  fromAnyToBool(selectRsInitVoidTransaction(state) || selectRsVoidTransactionDetails(state));

// noinspection JSUnusedGlobalSymbols
export default selectReqStatVoidTransaction;
